package ru.malygin.myConst

import ru.malygin.BuildConfig
import ru.malygin.CryptoUtils
import ru.malygin.Secret

object OnTopVariable {

    val APP_MODE = BuildConfig.MODE.toVersion()

    val APP_VERSION = BuildConfig.VERSION.plus("-${APP_MODE.shortName}")

    const val USED_DB = 1

    val VK_TOKEN_API = CryptoUtils.decrypt(BuildConfig.VK_API, Secret.VK_API_KEY)
    val VK_APP_ID = CryptoUtils.decrypt(BuildConfig.VK_APP_ID, Secret.VK_APP_ID_KEY).toInt()
    val VK_GROUP_ID = CryptoUtils.decrypt(BuildConfig.VK_GROUP_ID, Secret.VK_GROUP_ID_KEY).toLong()
    val VK_TOPIC_ID = CryptoUtils.decrypt(BuildConfig.VK_TOPIC_ID, Secret.VK_TOPIC_ID_KEY).toInt()
    val DATABASE_JVM_POSTGRES_USER = CryptoUtils.decrypt(BuildConfig.JVM_DB_USER, Secret.JVM_DB_USER_KEY).split("_").last()
    val DATABASE_JVM_POSTGRES_PASSWORD = CryptoUtils.decrypt(BuildConfig.JVM_DB_PASSWORD, Secret.JVM_DB_PASSWORD_KEY).split("_").last()

}

private const val devToVer = "DEVELOPMENT"
private const val prodToVer = "PRODUCTION"
private fun String.toVersion(): Versions {
    return when (this) {
        devToVer -> Versions.DEBUG
        prodToVer -> Versions.RELEASE
        else -> throw IllegalArgumentException("Unknown version: $this")
    }
}
